import { useMutation, useQueryClient } from "@tanstack/react-query";

import { AccessTokenSingleton } from "#modules/auth/domain/AccessTokenSingleton";
import { loginMutation } from "#modules/auth/infra/login.mutation";

type UseLoginOptions = {
  onSuccess?: () => void;
};

export const useLogin = (options?: UseLoginOptions) => {
  const queryClient = useQueryClient();

  return useMutation({
    ...loginMutation(),
    onSuccess: (data) => {
      if (data) {
        AccessTokenSingleton.getInstance().setAccessToken(data.accessToken);
        localStorage.setItem("accessTokenApi", data.accessToken);

        queryClient.clear();

        options?.onSuccess?.();
      }
    },
  });
};
